const USER_METADATA_KEY = 'https://hear.com'

export { USER_METADATA_KEY }
